import type { Lens } from '@dhmk/zustand-lens';

import { type Cart, SHOPIFY_ENV } from '@/clients/storefront/storefront.types';

export enum CartActions {
  ADD_ITEM = 'addItem',
  REMOVE_ITEM = 'removeItem',
  VIEW_CART = 'viewCart',
  UPDATE_QTY = 'updateQty',
}

export type SunrunShopState = {
  cartId: string | null;
  cart: Cart | null;
  storefrontCartEnv: SHOPIFY_ENV;
  isCartOpen: boolean;
  cartAction: CartActions;
  selectedQuantity: number;
};

export type SunrunShopActions = {
  setCartId: (id: string | null) => void;
  setCart: (cart: Cart | null) => void;
  setstorefrontCartEnv: (storefrontCartEnv: SHOPIFY_ENV) => void;
  setIsCartOpen: (isCartOpen: boolean) => void;
  setCartAction: (action: CartActions) => void;
};

export type SunrunShopSlice = SunrunShopState & { actions: SunrunShopActions };

const sliceName = 'sunrunShop';
export const createSunrunShopSlice: Lens<SunrunShopSlice> = (set) => ({
  cartId: null,
  cart: null,
  storefrontCartEnv: SHOPIFY_ENV.PROD,
  isCartOpen: false,
  selectedQuantity: 1,
  cartAction: CartActions.VIEW_CART,
  actions: {
    setCartId: (cartId) => set({ cartId }, undefined, `${sliceName}/setCartId`),
    setCart: (cart) => set({ cart }, undefined, `${sliceName}/setCart`),
    setstorefrontCartEnv: (storefrontCartEnv) =>
      set(
        { storefrontCartEnv },
        undefined,
        `${sliceName}/setstorefrontCartEnv`
      ),
    setIsCartOpen: (isCartOpen) =>
      set({ isCartOpen }, undefined, `${sliceName}/setIsCartOpen`),
    setCartAction: (cartAction) =>
      set({ cartAction }, undefined, `${sliceName}/setCartAction`),
  },
});
